import { createSelector } from '@reduxjs/toolkit';

export const IctDetailsSelector = (state) => state.IctDetailsReducer;

export const IctInventoryDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictDetailsInventoryData || {};
  }
);

export const IctDetailsLoadingSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.isLoading || false;
  }
);

export const IctInventoryResponseDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictDetailsInventoryResponse || {};
  }
);
export const IctInventoryPartialAnswersDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictInitialInventoryPartialAnswersData || {};
  }
);

export const IctEvaluationDetailsDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictEvaluationDetailsData || {};
  }
);
export const IctEvaluationPartialAnswersDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictEvaluationPartialAnswersData || {};
  }
);
export const IctEvaluationResponseDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictEvaluationResponseData || {};
  }
);
export const IctEvaluationConfirmDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictEvaluationConfirmData || {};
  }
);
export const IctFollowupDetailsDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictFollowupDetailsData || {};
  }
);
export const IctFollowupPartialAnswersDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictFollowupPartialAnswersData || {};
  },
);

export const IctFollowupResponseDataSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.ictFollowupResponseData || {};
  }
);
export const IctDetailsErrorSelector = createSelector(
  IctDetailsSelector,
  (state) => {
    return state?.errors || [];
  }
);